import type { MenuItem } from '@/consts/navigation';

export const buildDynamicSection = (
  allMenuItems: MenuItem[],
  section: MenuItem,
  codes: Set<string>,
  loading: boolean,
  emptyText: string
): MenuItem => {
  const items = Array.from(codes)
    .map((code) => allMenuItems.find((item) => item.code === code))
    .filter((item): item is MenuItem => item !== undefined);

  const children = loading ? [] : items.length > 0 ? items : [{ text: emptyText } as MenuItem];

  return { ...section, children };
};
